import request from '@/utils/request'
const baseUrl = '/upload'

/**
 * 上传封面
 * fileFormat 文件后缀(小写)
 * sts 是否启用STS鉴权
 * type 类型(avatar/cover)
 */
export function uploadCover(data) {
  return request({
    url: `${baseUrl}/private/rest/images`,
    method: 'POST',
    data
  })
}

/**
 * 先检查是否做了出售认证的登记(所有返回结果都以提示信息返回)
 */
export function checkVerified() {
  return request({
    url: `${baseUrl}/private/rest/checkVerified`,
    method: 'GET',
  })
}

/**
 * 上传素材作品
 */
export function materialWorks(data) {
  return request({
    url: `${baseUrl}/private/rest/materialWorks`,
    method: 'POST',
    data
  })
}

/**
 * 肖像权上传协议书
 */
export function uploadAgreement(data) {
  return request({
    url: `${baseUrl}/private/rest/uploadAgreement`,
    method: 'POST',
    data
  })
}

/**
 * 上传素材图片
 */
export function materialPicture(data) {
  return request({
    url: `${baseUrl}/private/rest/materialPicture`,
    method: 'POST',
    data
  })
}

/**
 * 上传素材音频
 */
export function materialMusics(data) {
  return request({
    url: `${baseUrl}/private/rest/materialMusics`,
    method: 'POST',
    data
  })
}

/**
 * 上传素材音频
 */
export function otherMaterial(data) {
  return request({
    url: `${baseUrl}/private/rest/otherMaterial`,
    method: 'POST',
    data
  })
}

/**
 * 上传素材视频封面
 */
export function uploadCoverVideo(data) {
  return request({
    url: `${baseUrl}/private/rest/uploadCoverVideo`,
    method: 'POST',
    data
  })
}

/**
 * 上传素材音频
 */
export function uploadTemplate(data) {
  return request({
    url: `${baseUrl}/private/rest/uploadTemplate`,
    method: 'POST',
    data
  })
}

/**
 * 上传素材音频
 */
export function uploadVirtual(data) {
  return request({
    url: `${baseUrl}/private/rest/uploadVirtualProperty`,
    method: 'POST',
    data
  })
}

/**
 * 下载素材
 */
export function downloadMaterial(data) {
  return request({
    url: `${baseUrl}/private/rest/downloadMaterial/${data.id}`,
    method: 'POST',
    data
  })
}

/**
 * 上传48作品
 */
export function upload48Video(data) {
  return request({
    url: `${baseUrl}/private/rest/upload48Video`,
    method: 'POST',
    data
  })
}

/**
 * 获取地区
 */
export function get48Addr(data) {
 return request({
   url: `${baseUrl}/private/rest/get48Addr`,
   method: 'GET',
   data
 })
}
